import { Box, Grid, Typography, TextField } from "@mui/material";
import styles from "../../Candidates/Candidate.module.css";
import { customTextColor } from "../../../utils/const";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";
import { IoIosArrowRoundBack } from "react-icons/io";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  checkCandidateExist,
  getAllCandidate,
} from "../../../redux/candidate/candidateSlice";
import { getProfile } from "../../../redux/profile/profileSlice";
import { addOfficialReference } from "../../../redux/InternalStatic/internalCandidateStatic";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const AddConsultantSubmit = ({ setMenuName, setMenuId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { formik1 } = location?.state || {};
  const { row } = location?.state || {};
  const profile = useSelector((state) => state.profile.data);
  const candidateStatus = useSelector((state) => state.candidate.status);
  const officialReferenceData = useSelector(
    (state) => state.internalCandidateStatic.officialReferenceData
  );
  const formik = useFormik({
    initialValues: {
      referrer_company_name:
        row?.referrer_company_name ||
        officialReferenceData?.referrer_company_name ||
        null,
      referrer_mobile_no:
        row?.referrer_mobile_no ||
        officialReferenceData?.referrer_mobile_no ||
        null,
      referrer_email:
        row?.referrer_email || officialReferenceData?.referrer_email || null,
      referrer_manager_name:
        row?.referrer_manager_name ||
        officialReferenceData?.referrer_manager_name ||
        null,
      referrer_manager_name2:
        row?.referrer_manager_name2 ||
        officialReferenceData?.referrer_manager_name2 ||
        null,
      referrer_company_name2:
        row?.referrer_company_name2 ||
        officialReferenceData?.referrer_company_name2 ||
        null,
      referrer_mobile_no2:
        row?.referrer_mobile_no2 ||
        officialReferenceData?.referrer_mobile_no2 ||
        null,
      referrer_email2:
        row?.referrer_email2 || officialReferenceData?.referrer_email2 || null,
    },
    onSubmit: (values) => {},
  });

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    let mobile_no = formik1?.mobile_no?.replace(/[^0-9]/g, "");
    let email = formik1?.email;

    dispatch(checkCandidateExist({ email, mobile_no }));
  }, [formik1]);

  const handleOnSubmitTracker = () => {
    dispatch(addOfficialReference(formik.values));
    setMenuName("Profile Review");
    setMenuId(3);
  };

  useEffect(() => {
    if (
      candidateStatus === "create_candidate_profile" ||
      candidateStatus === "create_candidate_exist_profile"
    ) {
      dispatch(getAllCandidate());
      navigate("/candidate-listing");
    }
  }, [candidateStatus]);

  useEffect(() => {
    if (profile !== null) {
      formik.setFieldValue("recruiter_user_id", profile?.profile?.user_id);
    }
  }, [profile]);

  return (
    <>
      <Box className={styles.candidate_structure} sx={{ marginTop: "0" }}>
        <Typography
          className={styles.add_candidate_heading}
          sx={{ margin: "0 !important", padding: "0 15px !important" }}
        >
          <b> Official Reference</b>
        </Typography>

        <Box className={styles.employer_details}>
          <Typography sx={{ color: customTextColor }}>
            1st Refference (Optional)
          </Typography>

          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiBuildingOfficeLight
                  style={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Company Name"
                variant="standard"
                sx={fieldStyle}
                name="referrer_company_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_company_name}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiUserLight style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Manager’s Name"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_manager_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_manager_name}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiMailboxLight
                  style={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Work Phone No"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_mobile_no"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_mobile_no}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Work E-Mail ID"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_email}
              />
            </Grid>
          </Grid>
        </Box>

        <Box className={styles.employer_details}>
          <Typography sx={{ color: customTextColor }}>
            2nd Refference (Optional)
          </Typography>

          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiBuildingOfficeLight
                  style={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Company Name"
                variant="standard"
                sx={fieldStyle}
                name="referrer_company_name2"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_company_name2}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiUserLight style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Manager’s Name"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_manager_name2"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_manager_name2}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Phone No"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_mobile_no2"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_mobile_no2}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="E-Mail ID"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_email2"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_email2}
              />
            </Grid>
          </Grid>
        </Box>

        <Box className={styles.add_consultant_btns}>
          <button
            onClick={() => {
              setMenuName("Skill and Experience");
              setMenuId(1);
            }}
            style={{
              border: "1.5px solid #4285f4",
              marginRight: "10px",
              padding: "6px 10px ",
              color: "#fff",
            }}
            disabled={candidateStatus === "loading"}
          >
            <IoIosArrowRoundBack style={{ fontSize: "25px", color: "#fff" }} />
          </button>
          <button
            onClick={handleOnSubmitTracker}
            style={
              candidateStatus === "loading"
                ? {
                    padding: "7px 40px",
                  }
                : {}
            }
            disabled={candidateStatus === "loading"}
          >
            {candidateStatus === "loading" ? "Loading..." : "Save Details"}{" "}
            <IoIosArrowRoundForward
              style={{ fontSize: "25px", marginLeft: "5px" }}
            />
          </button>
        </Box>
      </Box>
    </>
  );
};

export default AddConsultantSubmit;
